// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"advantages_wrapper__bKttt","content":"advantages_content__ulwb7","title":"advantages_title__nSI9n","advantages":"advantages_advantages__1UXHX"};